/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.currency.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.currency = {};
proto.witbooking.backoffice.currency.v1 = require('./currency_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.currency.v1.CurrencyAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.currency.v1.CurrencyAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.currency.v1.GetCurrenciesRequest,
 *   !proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse>}
 */
const methodDescriptor_CurrencyAPI_GetCurrencies = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.currency.v1.CurrencyAPI/GetCurrencies',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.currency.v1.GetCurrenciesRequest,
  proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse,
  /**
   * @param {!proto.witbooking.backoffice.currency.v1.GetCurrenciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.currency.v1.GetCurrenciesRequest,
 *   !proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse>}
 */
const methodInfo_CurrencyAPI_GetCurrencies = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse,
  /**
   * @param {!proto.witbooking.backoffice.currency.v1.GetCurrenciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.currency.v1.GetCurrenciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.currency.v1.CurrencyAPIClient.prototype.getCurrencies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.currency.v1.CurrencyAPI/GetCurrencies',
      request,
      metadata || {},
      methodDescriptor_CurrencyAPI_GetCurrencies,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.currency.v1.GetCurrenciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.currency.v1.GetCurrenciesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.currency.v1.CurrencyAPIPromiseClient.prototype.getCurrencies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.currency.v1.CurrencyAPI/GetCurrencies',
      request,
      metadata || {},
      methodDescriptor_CurrencyAPI_GetCurrencies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.currency.v1.GetCurrencyRequest,
 *   !proto.witbooking.backoffice.currency.v1.GetCurrencyResponse>}
 */
const methodDescriptor_CurrencyAPI_GetCurrency = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.currency.v1.CurrencyAPI/GetCurrency',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.currency.v1.GetCurrencyRequest,
  proto.witbooking.backoffice.currency.v1.GetCurrencyResponse,
  /**
   * @param {!proto.witbooking.backoffice.currency.v1.GetCurrencyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.currency.v1.GetCurrencyResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.currency.v1.GetCurrencyRequest,
 *   !proto.witbooking.backoffice.currency.v1.GetCurrencyResponse>}
 */
const methodInfo_CurrencyAPI_GetCurrency = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.currency.v1.GetCurrencyResponse,
  /**
   * @param {!proto.witbooking.backoffice.currency.v1.GetCurrencyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.currency.v1.GetCurrencyResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.currency.v1.GetCurrencyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.currency.v1.GetCurrencyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.currency.v1.GetCurrencyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.currency.v1.CurrencyAPIClient.prototype.getCurrency =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.currency.v1.CurrencyAPI/GetCurrency',
      request,
      metadata || {},
      methodDescriptor_CurrencyAPI_GetCurrency,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.currency.v1.GetCurrencyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.currency.v1.GetCurrencyResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.currency.v1.CurrencyAPIPromiseClient.prototype.getCurrency =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.currency.v1.CurrencyAPI/GetCurrency',
      request,
      metadata || {},
      methodDescriptor_CurrencyAPI_GetCurrency);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.currency.v1.UpdateCurrencyRequest,
 *   !proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse>}
 */
const methodDescriptor_CurrencyAPI_UpdateCurrency = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.currency.v1.CurrencyAPI/UpdateCurrency',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.currency.v1.UpdateCurrencyRequest,
  proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse,
  /**
   * @param {!proto.witbooking.backoffice.currency.v1.UpdateCurrencyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.currency.v1.UpdateCurrencyRequest,
 *   !proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse>}
 */
const methodInfo_CurrencyAPI_UpdateCurrency = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse,
  /**
   * @param {!proto.witbooking.backoffice.currency.v1.UpdateCurrencyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.currency.v1.UpdateCurrencyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.currency.v1.CurrencyAPIClient.prototype.updateCurrency =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.currency.v1.CurrencyAPI/UpdateCurrency',
      request,
      metadata || {},
      methodDescriptor_CurrencyAPI_UpdateCurrency,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.currency.v1.UpdateCurrencyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.currency.v1.UpdateCurrencyResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.currency.v1.CurrencyAPIPromiseClient.prototype.updateCurrency =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.currency.v1.CurrencyAPI/UpdateCurrency',
      request,
      metadata || {},
      methodDescriptor_CurrencyAPI_UpdateCurrency);
};


module.exports = proto.witbooking.backoffice.currency.v1;

